import { useUserInfo } from "@/hooks/useUserInfo";
import { SettingsSubscriptionFreeView } from "./SettingsSubscriptionFreeView";
import { SettingsSubscriptionProView } from "./SettingsSubscriptionProView";
import PageTitleScript from "@/components/MetaScript";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export function SettingsSubscriptionPage() {
  const { data: user } = useUserInfo();

  return (
    <div className="flex flex-col p-6">
      <PageTitleScript title="Pro Access" />
      <div className="flex items-center mb-6">
        <Link to="/settings" className="flex items-center gap-2">
          <ArrowLeft size={16} />
          <span className="text-base text-tx-dark">Back to Account</span>
        </Link>
      </div>

      <div className="flex items-center justify-center">
        {user?.subscription?.is_subscribed ? (
          <SettingsSubscriptionProView />
        ) : (
          <SettingsSubscriptionFreeView />
        )}
      </div>
    </div>
  );
}
